import apiClient from './api.service'
import { API_ENDPOINTS } from '@/config/api.config'

class UserService {
  /**
   * Get current user profile
   * @returns {Promise} User profile data
   */
  async getUserProfile() {
    const response = await apiClient.get(API_ENDPOINTS.USER_ME)
    return response.data
  }

  /**
   * Get list of available enterprises for current user
   * @returns {Promise} List of enterprises
   */
  async getEnterprises() {
    const response = await apiClient.get(API_ENDPOINTS.ENTERPRISES_LIST)
    return response.data
  }

  /**
   * Set current enterprise and get permissions
   * @param {number} enterpriseId - Enterprise ID to set as current
   * @returns {Promise} Enterprise data with permissions
   */
  async setEnterprise(enterpriseId) {
    const response = await apiClient.post(API_ENDPOINTS.SET_ENTERPRISE(enterpriseId))
    return response.data
  }
}

export default new UserService()

